import React, { useCallback, useState } from 'react'
import { Text } from '@usap/uicomponents'
import staticStyle from './CommentBestSeller.css'

const textLength = 85

export default function CommentBestSeller({ text }) {
  const [isExpand, setIsExpand] = useState(false)

  const handleExpand = useCallback(() => {
    if (isExpand) {
      setIsExpand(false)
    } else {
      setIsExpand(true)
    }
  }, [isExpand])

  let newText = text
  const difference = text.length - textLength
  if (text.length < textLength && difference < 10) {
    return (
      <>
        <Text style={staticStyle.commentText}>
          { text }
        </Text>
      </>
    )
  }
  newText = `${text.substr(0, textLength)}`
  if (!isExpand) {
    return (
      <>
        <Text style={staticStyle.commentText}>
          { newText }
          <Text style={staticStyle.seeMoreText} onClick={handleExpand}>
            See More
          </Text>
        </Text>
      </>
    )
  }
  return (
    <>
      <Text style={staticStyle.commentText}>
        { text }
        <Text style={staticStyle.seeMoreText} onClick={handleExpand}>
          Show Less
        </Text>
      </Text>
    </>
  )
}
